import * as React from 'react';
import * as styles from './ServicePosition.css';

interface IServicePositionProps {
  position: number | null;
  isLoading: boolean;
  isError: boolean;
}

export const ServicePosition = ({ position, isLoading, isError }: IServicePositionProps) => {
  if (isLoading) {
    return <div className={styles['label']}>Ищем страницу...</div>;
  }

  if (isError) {
    return <div className={styles['label']}>Страница не найдена</div>;
  }

  return <div className={styles['label']}>{position} страница поиска</div>;
};
